import React, { useState } from "react";
import { Checkbox } from "@mui/material";

export type CheckboxSectionProps = {
    title: string;
    list: string[];
    selected: string[];
    onToggle: (value: string) => void;
    onSet: (values: string[]) => void; // NEW!
};

const CheckboxSection: React.FC<CheckboxSectionProps> = ({
                                                             title,
                                                             list,
                                                             selected,
                                                             onToggle,
                                                             onSet
                                                         }) => {
    const [open, setOpen] = useState(false);

    const allSelected = selected.length === list.length;
    const someSelected = selected.length > 0 && !allSelected;

    const toggleAll = () => {
        if (allSelected) {
            // alles abwählen
            onSet([]);
        } else {
            // alles auswählen
            onSet([...list]);
        }
    };

    return (
        <div className="border border-gray-700 rounded-md overflow-hidden">

            {/* Header */}
            <button
                onClick={() => setOpen(!open)}
                className={`
          w-full flex justify-between items-center px-3 py-2 text-gray-300 text-sm transition
          hover:bg-gray-800/40
          ${open ? "bg-gray-800/40" : ""}
        `}
            >
                <span className="!text-[0.80rem] !font-semibold">{title}</span>
                <span className="!text-[0.80rem] !font-semibold">{open ? "▲" : "▼"}</span>
            </button>

            {/* Animated container */}
            <div
                className={`
          transition-all duration-300 ease-in-out overflow-hidden
          ${open ? "max-h-[9999px]" : "max-h-0"}
        `}
            >
                <div className="px-3 pb-3 pt-2 flex flex-col gap-1">

                    {/* CHECK ALL */}
                    <label className="flex items-center text-gray-300 !text-[0.80rem] !font-semibold mb-1">
                        <Checkbox
                            size="small"
                            checked={allSelected}
                            indeterminate={someSelected}
                            onChange={toggleAll}
                        />
                        Alle auswählen
                    </label>

                    {/* ITEMS */}
                    {list.map((item) => (
                        <label key={item} className="flex items-center text-gray-300 !text-[0.80rem] !font-semibold">
                            <Checkbox
                                size="small"
                                checked={selected.includes(item)}
                                onChange={() => onToggle(item)}
                            />
                            {item}
                        </label>
                    ))}
                </div>
            </div>

        </div>
    );
};

export default CheckboxSection;